export default __webpack_public_path__ + "static/media/blocks-desktop.3e146840.jpg";